import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { WecomMsOrgCallbackPage } from "@ms/shared-auth";

/** GIS 默认首页为集团运营（门店营收监控）页 */
const WecomCallbackPage: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  return (
    <WecomMsOrgCallbackPage
      navigate={navigate}
      searchParams={searchParams}
      afterLoginNavigateTo="/"
      onErrorNavigateTo="/store-revenue-monitor"
    />
  );
};

export default WecomCallbackPage;
